import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import {
    MatDialog,
    MatDialogRef,
    MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { Subscription } from 'rxjs';


@Component({
    selector: 'app-delete-modal',
    templateUrl: './delete-modal.component.html',
    styleUrls: ['./delete-modal.component.scss'],
})
export class DeleteModalComponent implements OnInit {
    connection: Subscription;
    constructor(
        public dialog: MatDialog,
        public dialogRef: MatDialogRef<DeleteModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: {title: string , body : string},
    ) {
    }

    ngOnInit(): void {
        this.dialogRef.disableClose = true;
    }
    onDeleteClick() {
        this.dialogRef.close(true);

    }
    close() {
        this.dialogRef.close(false);
    }
    ngOnDestroy(): void {
        if (this.connection) {
            this.connection.unsubscribe();
        }
    }
}
